// extracted by mini-css-extract-plugin
export default {"main":"_3c7a1fc060","tit":"_263af6c2ce","maintitle":"_62ae048099","ylw":"_33b840eb6b","white":"_37b4106ea9","mv_title":"_179abe4104","mv_nc":"_2936cae2d6","mv_in":"c15f7cfece"};